export class LFTabChangeEvent {
    public tabId: string;

    public hasError: boolean;
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/components/platform/lf-tabbedpane/lf-tab-change-event.ts